import React from 'react';
import { FiArrowRight } from 'react-icons/fi';
import { MdOutlineSecurity } from 'react-icons/md';

import { Button, Card, CardImage, ContentCard, Icon, Title } from './styles';

const FraudAlert: React.FC = () => {
  return (
    <ContentCard className="cards-intro">
      <Card>
        <CardImage image="static/card_alerta_fraude.png" />
        <Icon>
          <MdOutlineSecurity />
        </Icon>
        <Title>Fraude em boletos</Title>
        <Button
          href="https://www.ultragaz.com.br/golpe-do-boleto-falso-como-se-proteger"
          rel="noreferrer"
          target="_blank"
        >
          <span>Saiba mais</span>
          <FiArrowRight />
        </Button>
      </Card>
    </ContentCard>
  );
};

export default FraudAlert;
